// css
import '../../scss/pages/page-recruit-contact.scss';

// utils
import foundation from '../_utils/foundation';
foundation();

// npm
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// libs
import LinePathRepeat from '../_libs/LinePathRepeat';
import FvTitle from '../_libs/FvTitle';
import ScrollFadeAnimation from '../_libs/ScrollFadeAnimation';
import LinePath from '../_libs/LinePath';

document.addEventListener('DOMContentLoaded', () => {
	FvTitle();
	ScrollFadeAnimation();
	fv();

	inputErr();

	const submitButton = document.querySelector('#js-send-button');
	const submitLabel = document.querySelector('#js-send');

	submitButton.addEventListener('mouseenter', () => {
		submitLabel.classList.add('is-hover');
	});

	submitButton.addEventListener('mouseleave', () => {
		submitLabel.classList.remove('is-hover');
	});
});

window.addEventListener('load', () => {
	const line = new LinePath();
	line.observe();
});

function fv() {
	// アニメーション対象の要素を取得
	const itemsToAnimate = [];
	for (let i = 1; i <= 5; i++) {
		itemsToAnimate.push(document.querySelector(`.js-fv-item${i}`));
	}

	// 各要素に対してアニメーションを設定
	itemsToAnimate.forEach((item, index) => {
		if (!item) return; // 要素が存在しない場合はスキップ

		// 初期状態を設定
		gsap.set(item, {
			opacity: 0,
			yPercent: 30,
		});

		// アニメーションを設定
		gsap.to(item, {
			opacity: 1,
			yPercent: 0,
			duration: 1,
			ease: 'power4.out',
			delay: index * 0.15, // 各要素に0.15秒ずつ遅延を追加
			scrollTrigger: {
				trigger: item,
				start: 'top 90%',
				toggleActions: 'play none none none',
			},
			onComplete: () => {
				// アニメーション完了0.5秒後に実行
				setTimeout(() => {
					// 要素内のjs-repeat-itemクラスを持つ子要素を探す
					const repeatItem = item.querySelector('.js-repeat-item');
					// 子要素が存在すれば、is-activeクラスを追加
					if (repeatItem) {
						repeatItem.classList.add('is-active');
					}
				}, 500);
			},
		});
	});

	setTimeout(() => {
		LinePathRepeat();
	}, 100);
}

function inputErr() {
	// エラーが発生した時
	let margnEle = 90;
	if (window.matchMedia('(min-width: 768px)').matches) {
		margnEle = 100;
	}
	let wpcf7El = document.querySelector('.wpcf7');

	// エラーが発生した時
	wpcf7El.addEventListener(
		'wpcf7invalid',
		function scrollToFirstError() {
			setTimeout(function () {
				let firstErrorEl = document.querySelector(
					'.wpcf7-not-valid:first-child'
				); // エラーが発生した1番目の要素を取得

				let scrollAmount =
					firstErrorEl.getBoundingClientRect().top +
					window.pageYOffset -
					margnEle;

				window.scrollTo({
					top: scrollAmount,
					behavior: 'smooth',
				}); // 該当箇所までスクロール
			}, 200);
		},

		false
	);
}
